import { measurementPointTypesEnum } from '../../models-enums';

/*
 * Column widths for the measurement point form controls.
 * Guide text always spans the full row and wraps under the input instead of sitting
 * beside it in a 2 or 3 unit column, which left the text in a narrow left justified
 * box with dead space next to it on every screen size.
 */
export const getFormColumnWidths = (
    isMobile: boolean,
    allowNotes: boolean | undefined,
    guideText: string | undefined,
    measurementPointType: measurementPointTypesEnum
) => {
    const columnWidths = {
        mainCol: isMobile ? 12 : 6,
        labelCol: isMobile ? 6 : 3,
        measurementPointCol: 12,
        guideCol: 0,
        noteCol: 0
    };

    if (allowNotes) {
        return {
            ...columnWidths,
            mainCol: 10,
            measurementPointCol: isMobile ? 12 : 10,
            guideCol: 12,
            noteCol: 2
        };
    } else if (guideText) {
        return {
            ...columnWidths,
            mainCol: 9,
            measurementPointCol: isMobile ? 12 : 9,
            guideCol: 12,
            labelCol: 3
        };
    } else if (measurementPointType === measurementPointTypesEnum.group) {
        return {
            ...columnWidths,
            mainCol: 12
        };
    }

    return columnWidths;
};
